import {
    STOCK_TAKING_CAR_MANAGEMENT_MODELS_DATA_MASTER_BEGIN,
  } from '../constants';
  
  export function getModelsDataMaster(brandId) {
    return (dispatch) => {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_MODELS_DATA_MASTER_BEGIN,
        data: { brandId }
      })
    }
  }